import { alpha, Button, Stack, styled } from '@mui/material';
import { getNavFloatShadow } from 'src/components/Navbar/DesktopDrawer/desktop-drawer.styles';
import { GLASS_BLUR, SUPPORTS_BACKDROP_FILTER } from 'src/constants/glass';

export type StatePanelTone = 'neutral' | 'danger';

export const StatePanelRoot = styled(Stack, {
  name: 'ConversationStatePanel',
  shouldForwardProp: (prop) => prop !== 'hasBannerAbove',
})<{ hasBannerAbove: boolean }>(({ theme, hasBannerAbove }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '0.875rem',
  padding: '0.8125rem 0.875rem 0.8125rem 1rem',
  // a banner above squares the top corners so the stack reads as one sheet, like the card
  borderRadius: hasBannerAbove ? '0 0 0.75rem 0.75rem' : '0.75rem',
  border: `1px solid ${alpha(theme.palette.custom.OV.sys.outlineVariant, 0.75)}`,
  backgroundColor: alpha(theme.palette.custom.OV.sys.surfaceContainerLowest, 0.82),
  backdropFilter: GLASS_BLUR,
  WebkitBackdropFilter: GLASS_BLUR,
  boxShadow: getNavFloatShadow(theme),
  [SUPPORTS_BACKDROP_FILTER]: {
    backgroundColor: theme.palette.custom.OV.sys.surfaceBright,
  },
}));

export const StatePanelText = styled(Stack, { name: 'ConversationStatePanelText' })({
  gap: '0.125rem',
  minWidth: 0,
  flex: '1 1 12.5rem',
});

export const StatePanelActions = styled(Stack, { name: 'ConversationStatePanelActions' })({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '0.5rem',
  flexShrink: 0,
  marginLeft: 'auto',
});

/** Shared metrics for the panel actions; colour comes from the MUI variant/color the caller picks. */
export const StatePanelButton = styled(Button, { name: 'ConversationStatePanelButton' })(
  ({ theme }) => ({
    gap: '0.4375rem',
    borderRadius: '0.5625rem',
    padding: '0.5625rem 0.875rem',
    fontSize: '0.78125rem',
    fontWeight: 650,
    lineHeight: 1.2,
    textTransform: 'none',
    whiteSpace: 'nowrap',
    minWidth: 0,
    '& .MuiButton-startIcon': { margin: 0 },
    '&.MuiButton-contained': {
      boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.3)}`,
      '&:hover': {
        boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.3)}`,
        filter: 'brightness(1.07)',
      },
    },
  }),
);
